export default "__VITE_ASSET__vqe20sZK__"